var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakerOff24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.2V11.8C1 10.1198 1 9.27972 1.32698 8.63799C1.6146 8.0735 2.07354 7.61456 2.63803 7.32694C3.27976 6.99996 4.11984 6.99996 5.8 6.99996H6.13288C6.82317 6.99996 7.16831 6.99996 7.4953 6.92595C7.78529 6.86032 8.06391 6.75194 8.32203 6.60437C8.61308 6.43797 8.86751 6.20475 9.37636 5.7383L11.3188 3.95769C12.1668 3.18039 12.5908 2.79175 12.9519 2.77435C13.2655 2.75925 13.568 2.89232 13.7688 3.13371C14 3.41166 14 3.98682 14 5.13714V18.8628C14 20.0131 14 20.5883 13.7688 20.8662C13.568 21.1076 13.2655 21.2407 12.9519 21.2256C12.5908 21.2082 12.1668 20.8195 11.3188 20.0422L9.37636 18.2616C8.86751 17.7952 8.61308 17.562 8.32203 17.3956C8.06391 17.248 7.78529 17.1396 7.4953 17.074C7.16831 17 6.82317 17 6.13288 17H5.8C4.11984 17 3.27976 17 2.63803 16.673C2.07354 16.3854 1.6146 15.9264 1.32698 15.3619C1 14.7202 1 13.8801 1 12.2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2929 8.79285C15.6834 8.40233 16.3166 8.40233 16.7071 8.79285L18.5 10.5857L20.2929 8.79285C20.6834 8.40233 21.3166 8.40233 21.7071 8.79285C22.0976 9.18338 22.0976 9.81654 21.7071 10.2071L19.9142 12L21.7071 13.7929C22.0976 14.1834 22.0976 14.8165 21.7071 15.2071C21.3166 15.5976 20.6834 15.5976 20.2929 15.2071L18.5 13.4142L16.7071 15.2071C16.3166 15.5976 15.6834 15.5976 15.2929 15.2071C14.9024 14.8165 14.9024 14.1834 15.2929 13.7929L17.0858 12L15.2929 10.2071C14.9024 9.81654 14.9024 9.18338 15.2929 8.79285Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerOff24);
export default __webpack_public_path__ + "static/media/speaker-off-24.36a22668e8697a5a0b232dc3fa53af81.svg";
export { ForwardRef as ReactComponent };